import { connect } from "react-redux";
import * as Redux from "redux";
import { userLogin } from "../../actions";
import Protected from "./component";
import { withRouter } from "react-router-dom";

import { userPermitted } from "../../selectors";

const mapStateToProps = (state: any): any => {
  return {
    permit: userPermitted(state)
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>): any => {
  return {
    ...Redux.bindActionCreators({ userLogin }, dispatch)
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Protected) as any
);



// WEBPACK FOOTER //
// ./client/modules/User/components/Protected/container.ts